import { useHistory } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { Text_INTERNAL } from "@/react/components/shared/uikit/Typography/components/Text_INTERNAL";
import { usePunditUserContext } from "@circle-react/contexts";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Typography } from "@circle-react-uikit/Typography";
import circleAIBotAvatar from "../assets/icons/CircleAIBot-avatar.png";
import { HomePageCtaButtons } from "../components/HomePageCtaButtons";
import { HelpInputArea } from "../components/common/HelpInputArea";
import { HelpWidgetLayout } from "../components/common/HelpWidgetLayout";
import { useCreateChat } from "../hooks/useCreateChat";

export const HomePage = () => {
  const {
    currentCommunityMember,
    currentCommunitySettings,
    isLoading: isLoadingPunditUserContext,
  } = usePunditUserContext();
  const history = useHistory();

  const isCopilotActionsEnabled =
    !isLoadingPunditUserContext && currentCommunitySettings?.copilot_v2_enabled;

  const isCopilotV2Enabled =
    !isLoadingPunditUserContext && currentCommunitySettings?.copilot_v2_enabled;

  const { mutate: createChat } = useCreateChat({
    onSuccess: (data: { id: string }) => {
      history.push(`/conversations/${data.id}`);
    },
    onError: (error: unknown) => {
      console.error("Error creating chat", error);
    },
  });

  const handleHelpSubmit = (text: string) => {
    createChat({ text });
  };

  return (
    <HelpWidgetLayout
      className={classNames(
        "flex h-full min-h-[582px] flex-col items-center pb-px",
        {
          "justify-center": isCopilotActionsEnabled,
          "justify-end": !isCopilotActionsEnabled || isCopilotV2Enabled,
        },
      )}
    >
      <div className="flex w-full flex-col items-center px-4">
        {/* Circle AI Bot Avatar */}
        <div className="relative z-10 flex size-16 items-center justify-center">
          <img
            src={circleAIBotAvatar}
            alt={t("help_widget.home_page.circle_ai_bot_alt")}
            className="size-full rounded-full object-contain"
            loading="eager"
          />
        </div>

        {/* Greeting */}
        <div className="mt-4 flex items-center gap-2 text-center">
          <Text_INTERNAL
            as="span"
            color="text-gray-900 dark:text-gray-50"
            weight="font-semibold"
            size="text-2xl"
            leading="leading-[32px]"
            tracking="tracking-[0]"
            textAlign=""
          >
            {t("help_widget.home_page.greeting", {
              first_name:
                currentCommunityMember?.first_name ||
                t("help_widget.home_page.default_greeting_name"),
            })}
          </Text_INTERNAL>
        </div>
        <div className="mt-1">
          <Typography.LabelSm
            color="text-default dark:text-feature-light"
            weight="medium"
          >
            {t("help_widget.home_page.help_text")}
          </Typography.LabelSm>
        </div>

        <HomePageCtaButtons />

        {(!isCopilotActionsEnabled || isCopilotV2Enabled) && (
          <div className="mt-[88px] w-full">
            <HelpInputArea
              onSubmit={handleHelpSubmit}
              placeholder={t("help_widget.home_page.help_input_placeholder")}
              allowAttachments={false}
            />
          </div>
        )}
      </div>
    </HelpWidgetLayout>
  );
};
